import React from 'react';

import ReferencesPage from "./ReferencesPage";

interface ReferencesPageProps {}

const ReferencesPageContainer: React.FC<ReferencesPageProps> = () => {
    return <ReferencesPage />
}

export default ReferencesPageContainer;